import react from "react";
import MenuEmpresas from "./menuempresas";

export default function DisenoEmpresas() {
  return <MenuEmpresas />;
}
